module.exports = __webpack_public_path__ + "static/media/ge.e25ad0ec.svg";